export const defaultValues = {
  firstname: '',
  middlename: '',
  lastname: '',
  candidateId: '',
  email: '',
  contact: '',
  gender: '',
  educations: [
    {
      institution: '',
      qualification: '',
      graduationYear: '',
      fieldsOfStudy: '',
      gradeType: 'MARKS',
      maxMarks: '',
      earnedMarks: '',
      maxGPA: '',
      earnedGPA: '',
      board: '',
      university: '',
    },
  ],
  workExperiences: [
    {
      company: '',
      role: '',
      employment_period: {
        startMonth: '',
        startYear: '',
        endMonth: '',
        endYear: '',
        present: false,
      },
      duties: [],
    },
  ],
  skills: [],
  certifications: [],
  noticePeriod: '',
};

export const educations = [
  { id: 1, value: 'TENTH', label: 'Secondary' },
  { id: 2, value: 'TWELFTH', label: 'Higher Secondary' },
  { id: 5, value: 'DIPLOMA', label: 'Diploma' },
  { id: 3, value: 'DEGREE', label: "Bachelor's Degree" },
  { id: 4, value: 'MASTERS', label: "Master's Degree" },
];

export const fieldStudyOptions = [
  { id: 1, value: 'finance', label: 'Finance' },
  { id: 2, value: 'accounting', label: 'Accounting' },
  { id: 3, value: 'economics', label: 'Economics' },
  { id: 4, value: 'business', label: 'Business Administration' },
  { id: 5, value: 'law', label: 'Law' },
  { id: 6, value: 'riskManagement', label: 'Risk Management' },
  { id: 7, value: 'informationSystems', label: 'Information Systems' },
  { id: 8, value: 'dataScience', label: 'Data Science/Analytics' },
];
export const boardOptions = [
  { id: 1, value: 'STATE', label: 'State' },
  { id: 2, value: 'CBSE', label: 'CBSE' },
  { id: 3, value: 'ICSE', label: 'ICSE' },
  { id: 4, value: 'IB', label: 'IB' },
  { id: 5, value: 'IGCSE', label: 'IGCSE' },
];

export const getEmptyEducation = () => ({
  institution: '',
  qualification: '',
  graduationYear: '',
  fieldsOfStudy: '',
  gradeType: 'MARKS',
  maxMarks: '',
  earnedMarks: '',
  maxGPA: '',
  earnedGPA: '',
  board: '',
  university: '',
});

/** True when the row has no user-visible education data (optional blank "Add Education" row). */
export function isBlankEducationEntry(edu) {
  if (!edu) return true;
  const has = (v) => {
    if (v === undefined || v === null || v === false) return false;
    if (typeof v === 'string') return v.trim() !== '';
    if (typeof v === 'number') return !Number.isNaN(v);
    return String(v).length > 0;
  };
  return !(
    has(edu.institution) ||
    has(edu.qualification) ||
    has(edu.graduationYear) ||
    has(edu.fieldsOfStudy) ||
    has(edu.board) ||
    has(edu.university) ||
    has(edu.maxMarks) ||
    has(edu.earnedMarks) ||
    has(edu.maxGPA) ||
    has(edu.earnedGPA)
  );
}

export function filterNonBlankEducations(list) {
  return (list || []).filter((e) => !isBlankEducationEntry(e));
}

export const getEmptyWorkExperience = () => ({
  company: '',
  role: '',
  employment_period: {
    startMonth: '',
    startYear: '',
    endMonth: '',
    endYear: '',
    present: false,
  },
  duties: [],
});

/** Ensure each work experience has a `duties` array for the form. */
export function mapWorkExperiencesWithDuties(list) {
  return (list || []).map((exp) => ({
    ...exp,
    duties: Array.isArray(exp.duties)
      ? exp.duties.map((d) => {
          const title = d.title != null ? String(d.title) : '';
          const description =
            d.description != null ? String(d.description) : '';
          return {
            id: d?.id ?? null,
            title,
            description,
            // Last value synced to the backend. Live duty ops update this; the
            // Save-Changes flush compares against it to find un-synced edits.
            _baseline: { title, description },
          };
        })
      : [],
  }));
}

export function generateDutyTitleFromDescription(description) {
  const desc = String(description || '').trim();
  if (!desc) return '';

  // Match v11 logic: use prefix before common separators, otherwise first 4 words.
  const prefixFromSeparator = [':', ' – ', ' - ']
    .map((sep) => {
      if (!desc.includes(sep)) return '';
      const prefix = desc.split(sep)[0].trim();
      if (prefix.length >= 3 && prefix.length <= 50) return prefix;
      return '';
    })
    .find(Boolean);

  if (prefixFromSeparator) return prefixFromSeparator;

  const words = desc.split(/\s+/).slice(0, 4);
  return words.join(' ');
}

/** Drop incomplete duty rows; trim strings (API payload). */
export function sanitizeWorkExperienceDuties(exp) {
  const MAX_DUTY_DESC_CHARS = 700;
  const duties = (exp.duties || [])
    .filter((d) => String(d?.description || '').trim())
    .map((d) => {
      const rawDesc = String(d?.description || '').trim();
      const description = rawDesc.slice(0, MAX_DUTY_DESC_CHARS);
      const rawTitle = String(d?.title || '').trim();
      const title = rawTitle || generateDutyTitleFromDescription(description);
      // Keep the backend duty id (when present) so the save round-trips it.
      return d?.id != null
        ? { id: d.id, title, description }
        : { title, description };
    });
  return { ...exp, duties };
}
